export default "__VITE_ASSET__DqICERNW__"